<template>
  <div class="post-wrapper" style="cursor: text !important">
    <div class="row m-b-10">
      <div class="col-md-12 col-sm-12">
        <div
          class="row"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-left: 0px !important;
            margin-right: 0px !important;
          "
        >
          <div class="col-md-8 p-l-0">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-12">
                <div
                  class="sort-el"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                  "
                >
                  <div
                    class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                    id="post-sort"
                  >
                    <select
                      name="sort"
                      v-model="sort"
                      class="form-control"
                      style="height:2.55rem;border-right: none !important;"
                    >
                      <option value="esmr">Terpopuler</option>
                      <option value="date">Terbaru</option>
                      <option value="dateOld">Terlama</option>
                      <option value="engagement">Engagement</option>
                    </select>
                    <div
                      class="input-group-append"
                      style="border-left:none !important"
                    >
                      <span class="input-group-text transparent">
                        <i
                          class="bi bi-sort-down-alt"
                          style="font-size: 18px"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div
                    class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                    id="post-per-page"
                  >
                    <select
                      name="sort"
                      v-model="per_page"
                      class="form-control"
                      style="height:2.55rem;border-right: none !important;"
                    >
                      <option value="10">10 Post per Halaman</option>
                      <option value="25">25 Post per Halaman</option>
                      <option value="50">50 Post per Halaman</option>
                      <option value="100">100 Post per Halaman</option>
                      <option value="500">500 Post per Halaman</option>
                      <option value="1000">1000 Post per Halaman</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-file-earmark-break" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div
                    class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                    id="post-pers-filter"
                  >
                    <select
                      name="sort"
                      v-model="isPers"
                      class="form-control"
                      style="height:2.55rem;border-right: none !important;"
                    >
                      <option value="2">Tampilkan Semua</option>
                      <option value="1">Tampilkan Pers</option>
                      <option value="0">Tampilkan Non Pers</option>
                    </select>
                    <div class="input-group-append">
                      <span class="input-group-text transparent">
                        <i class="bi bi-eye" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-12 m-t-10 mt-md-0">
                <div class="perpage-el">
                  <div
                    class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                    id="post-tier-filter"
                  >
                    <multiselect
                      v-model="multiple_tier"
                      :options="tier_options"
                      :multiple="true"
                      :limit="1"
                      :searchable="false"
                      placeholder="Semua Tier"
                      label="name"
                      track-by="name"
                      @input="tierChanged"
                    >
                      <template slot="limit">
                        <span class="multiselect__strong">
                          +(
                          {{
                            Array.isArray(multiple_tier)
                              ? multiple_tier.length - 1
                              : 0
                          }})
                        </span>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 p-r-0 m-t-10 mt-md-0">
            <div class="d-flex">
              <form
                action="#"
                id="post-search-form"
                @submit.prevent="searchPost"
                class="ml-auto mr-2 w-100"
              >
                <div class="form-group-lg input-group input-group-right">
                  <input
                    type="text"
                    placeholder="Cari..."
                    v-model="search"
                    class="form-control"
                    style="height:2.55rem;border-right: none !important;"
                  />
                  <div class="input-group-append">
                    <span
                      @click="searchPost"
                      class="input-group-text complete"
                      style="cursor: pointer; border: none !important"
                    >
                      <i class="bi bi-search" />
                    </span>
                  </div>
                </div>
              </form>
              <button
                id="advance"
                class="btn btn-secondary rounded"
                style="cursor: pointer; padding-left: 5px; padding-right: 5px"
                v-tooltip.top="{ ref: 'advance-search' }"
                @click="showAdvanceSearch()"
              >
                <i class="bi bi-funnel-fill"></i>
              </button>
              <div ref="advance-search" class="tooltip-content">
                <b>Advance Search</b>
              </div>
              <button
                v-if="isFilter"
                @click="resetFilter"
                class="btn btn-danger ml-2"
                style="cursor: pointer"
              >
                <i class="bi bi-trash" />
              </button>
            </div>
          </div>
        </div>
        <div
          class="row m-t-10"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-left: 0px !important;
            margin-right: 0px !important;
          "
        >
          <div v-if="isAdmin" class="col-md-2 col-6 p-l-0">
            <div
              class="form-check success m-b-0"
              style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
              "
              id="post-tandai-semua"
            >
              <input type="checkbox" id="checkAll" v-model="check_all" />
              <label for="checkAll"> Tandai Semua </label>
            </div>
          </div>

          <div
            v-if="tipe_project == 1"
            :class="isAdmin ? 'col-md-3' : 'col-md-5'"
          >
            <div
              class="form-check warning m-b-0"
              style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
              "
              id="post-highlight"
            >
              <input
                type="checkbox"
                v-model="is_highlight"
                id="showHighlight"
              />
              <label for="showHighlight">
                Tampilkan hanya yang dihighlight
              </label>
            </div>
          </div>

          <div
            class="p-r-0 m-t-10 mt-md-0"
            :class="tipe_project == 1 ? 'col-md-7' : 'col-md-10'"
          >
            <div class="pull-right" id="post-pagination">
              <pagination-component :data="page_info" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 m-t-10" id="action-tersembunyi">
        <div class="bg-success-lighter p-l-10 p-t-5 p-b-5 p-r-10 rounded">
          <div class="row m-b-5">
            <div class="col-md-12">
              <b class="m-b-5">Aksi untuk item yang ditandai</b>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin-left: 0px !important;
              margin-right: 0px !important;
            "
          >
            <div class="p-l-0 mb-1 mr-1">
              <div
                class="sentimen-checked-el"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                "
              >
                <select
                  name="sentiment_checked"
                  v-model="sentiment_checked"
                  class="form-sorting-post form-control form-control-sm bg-white"
                >
                  <option value="" disabled="" selected="">
                    Ubah Sentimen
                  </option>
                  <option value="1">Positif</option>
                  <option value="0">Netral</option>
                  <option value="-1">Negatif</option>
                </select>
              </div>
            </div>
            <div class="p-l-0 mb-1 mr-1">
              <div
                class="sentimen-checked-el"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                "
              >
                <select
                  name="emotion_checked"
                  v-model="emotion_checked"
                  class="form-sorting-post form-control form-control-sm bg-white"
                >
                  <option value="" disabled="" selected="">Ubah Emotion</option>
                  <option value="0">Netral</option>
                  <option value="1">Senang</option>
                  <option value="2">Takut</option>
                  <option value="3">Sedih</option>
                  <option value="4">Marah</option>
                </select>
              </div>
            </div>
            <div class="mr-auto p-l-0 mb-1">
              <button
                @click="validatePostAll()"
                class="btn btn-warning btn-icon-left mr-1"
              >
                <i class="bi bi-patch-check"></i>
                <span>Validasi</span>
              </button>
              <button
                id="kliping-pdf"
                class="btn btn-danger btn-icon-left mr-1"
              >
                <i class="bi bi-file-earmark-pdf md-18"></i>
                <span>Kliping PDF</span>
              </button>
              <b-popover triggers="hover" target="kliping-pdf">
                <div>
                  <b-form-checkbox v-model="kliping.ad_value">
                    AD Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.pr_value">
                    PR Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.tipe_media">
                    Tipe Media
                  </b-form-checkbox>
                  <b-button
                    @click="eksporSelectedKliping('pdf')"
                    variant="success"
                    class="mt-3 w-100"
                  >
                    Download
                  </b-button>
                </div>
              </b-popover>
              <button
                id="kliping-word"
                class="btn btn-complete btn-icon-left mr-1"
              >
                <i class="bi bi-file-earmark-word md-18"></i>
                <span>Kliping DOCX</span>
              </button>
              <b-popover triggers="hover" target="kliping-word">
                <div>
                  <b-form-checkbox v-model="kliping.ad_value">
                    AD Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.pr_value">
                    PR Value
                  </b-form-checkbox>
                  <b-form-checkbox v-model="kliping.tipe_media">
                    Tipe Media
                  </b-form-checkbox>
                  <b-button
                    @click="eksporSelectedKliping('docx')"
                    variant="success"
                    class="mt-3 w-100"
                  >
                    Download
                  </b-button>
                </div>
              </b-popover>
              <button
                v-if="news_trend > 0 && is_newstrend == 'manage'"
                @click="addNewsTrendModal"
                class="btn btn-complete btn-icon-left"
              >
                <i class="bi bi-plus md-18"></i>
                <span>News Trend</span>
              </button>
            </div>
            <div class="ml-auto p-l-0 mb-1">
              <button
                class="btn btn-danger pull-right btn-icon-left"
                @click="deleteChecked"
              >
                <i class="bi bi-trash"></i> Hapus Posting
              </button>
              <button
                @click="sharePost"
                class="btn btn-success pull-right mr-1"
              >
                <span class="bi bi-share mr-1" /> <span>Bagikan</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="post-items">
      <div v-if="!data" class="col-md-12 col-sm-12 col-lg-12">
        <div
          class="alert alert-danger mt-3"
          id="errorApiEl"
          role="alert"
          align="center"
        >
          <strong>Mohon maaf, data tidak tersedia! </strong> <br />
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
      <div v-else class="scroller" style="max-height: 45.8rem">
        <div
          v-for="(post, index) in data"
          :key="index"
          :index="index"
          class="card card-default social-card share col1 m-b-5"
          data-social="item"
          style="width: 100%; cursor: text !important"
        >
          <div class="card-header bg-white" style="cursor: text !important">
            <div class="row post-content">
              <div class="col-md-1 col-xs-12" align="center">
                <div class="user-pic">
                  <img
                    alt="Profile Image"
                    :data-src-retina="post | showPicture"
                    :data-src="post | showPicture"
                    :src="post | showPicture"
                    class="img-circle"
                    @error="imageUrlAlt"
                  />
                  <div class="col-md-2 propic-badge" v-if="post.source">
                    <i
                      :class="sosmed_icon[post.source] + ' icon-' + post.source"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-11">
                <h5 class="row">
                  <span
                    class="pull-left hoverable account-name col-10"
                    style="cursor: pointer !important"
                    @click="viewAccountDetail(post)"
                  >
                    <span v-if="post.source === 'twitter'">@</span>
                    <span>
                      {{
                        sosmed_list.includes(post.source) && post.source != 'youtube' 
                        ? post.account 
                        : post.apps ? post.apps.name : post.title
                      }}
                    </span>
                    <span
                      v-if="cekPers(post.id_account)"
                      class="bg-orange label text-white p-t-1 p-b-1 fs-10"
                    >
                      Pers
                    </span>
                    <span
                      class="bg-danger label text-white p-t-1 p-b-1 fs-10 m-l-5"
                      v-if="hoax_detection && sosmed_list.includes(post.source)"
                    >
                      HOAX 30%
                    </span>
                    <span
                      class="bg-success label text-white p-t-1 p-b-1 fs-10 m-l-5"
                      v-if="hoax_detection && sosmed_list.includes(post.source)"
                    >
                      FAKTA 70%
                    </span>
                  </span>
                  <div
                    :id="'validation-status-' + index"
                    class="tooltip-content"
                  >
                    <p class="text-black">Status Validasi</p>
                    <p class="text-black">
                      Sentimen:
                      <b>
                        <span
                          v-if="post.updated_sentiment"
                          class="text-success"
                        >
                          Sudah divalidasi
                        </span>
                        <span v-else class="text-danger">
                          Belum divalidasi
                        </span>
                      </b>
                    </p>
                    <p class="text-black">
                      Emotion:
                      <b>
                        <span v-if="post.updated_emotion" class="text-success">
                          Sudah divalidasi
                        </span>
                        <span v-else class="text-danger">Belum divalidasi</span>
                      </b>
                    </p>
                  </div>
                  <div :id="'tanggal-release-' + index" class="tooltip-content">
                    <p class="text-black">Detail Tanggal</p>
                    <p class="text-black">
                      Publikasi:
                      <b>
                        <span class="text-success">
                          {{
                            post.source == "media_cetak" ||
                            post.source == "media_tv"
                              ? convertDate(post.date.$date)
                              : dateindo(post.date.$date)
                          }}</span
                        >
                      </b>
                    </p>
                    <p class="text-black">
                      Tersimpan:
                      <b>
                        <span class="text-success">
                          {{
                            post.source == "media_cetak" ||
                            post.source == "media_tv"
                              ? convertDate(post.input_date.$date)
                              : dateindo(post.input_date.$date)
                          }}</span
                        >
                      </b>
                    </p>
                  </div>
                  <span
                    class="pull-right fs-12 col-2"
                    style="margin-top: 2px !important"
                  >
                    <span
                      v-tooltip.top="{
                        html: 'tanggal-release-' + index,
                        class: 'tooltip-custom',
                      }"
                    >
                      <i class="bi bi-calendar-event" />
                      {{
                        post.source == "media_cetak" ||
                        post.source == "media_tv"
                          ? convertDate(post.date.$date)
                          : dateindo(post.date.$date)
                      }}
                    </span>
                    <span
                      v-if="
                        'updated_emotion' in post || 'updated_sentiment' in post
                      "
                      class="pull-right"
                      style="margin-top: 0px !important; font-size: 22px"
                      v-tooltip.top="{
                        html: 'validation-status-' + index,
                        class: 'tooltip-custom',
                      }"
                    >
                      <i class="i bi-patch-check text-success" />
                    </span>
                    <span
                      v-else
                      class="pull-right"
                      style="margin-top: 0px !important; font-size: 22px"
                      v-tooltip.top="{
                        html: 'validation-status-' + index,
                        class: 'tooltip-custom',
                      }"
                    >
                      <i class="i bi-patch-check text-secondary" />
                    </span>
                  </span>
                  <div class="clearfix" />
                </h5>
                <div class="clearfix"></div>
                <div class="d-flex align-items-center post-meta p-t-5">
                  <div
                    v-if="sosmed_list.includes(post.source)"
                    class="engagement-detail"
                  >
                    <span v-if="post.source != 'youtube'">
                      <span
                        v-for="(engagement, e_index) in post.engagement_detail"
                        :key="e_index"
                        :title="post_attribute[e_index]"
                        class="m-r-5 post-number"
                      >
                        <i :class="post_meta[e_index]" />
                        {{ engagement | kmbFormatter }}
                      </span>
                    </span>
                    <span v-else>
                      <span
                        v-for="(engagement, e_index) in post.engagement_detail"
                        :key="e_index"
                        :title="youtube_attribute[e_index]"
                        class="m-r-5 post-number"
                      >
                        <i :class="youtube_meta[e_index]" />
                        {{ engagement | kmbFormatter }}
                      </span>
                    </span>
                    <span
                      v-if="post.source == 'review'"
                      class="post-number m-r-5"
                      title="Score"
                    >
                      <i class="bi bi-star-fill" />
                      {{ post.score ? post.score : 0 | kmbFormatter }}
                    </span>
                    <span
                      v-if="post.source == 'review'"
                      class="post-number m-r-5"
                      title="Score"
                    >
                      <i
                        v-if="post.data_source == 'playstore'"
                        class="bi bi-android m-r-5"
                      />
                      <i v-else class="bi bi-apple m-r-5" />
                      <span v-if="post.data_source == 'playstore'"
                        >Play Store</span
                      >
                      <span v-else>App Store</span>
                    </span>
                    <span
                      v-if="post.source != 'review'"
                      class="post-number"
                      title="Followers"
                    >
                      <i class="bi bi-people" />
                      {{ post.followers ? post.followers : 0 | kmbFormatter }}
                    </span>

                    <span v-if="post.source != 'review'" class="separator"
                      >|</span
                    >
                    <span
                      v-if="post.source != 'review'"
                      class="m-l-5 post-number"
                      title="Reach"
                    >
                      <i class="bi bi-megaphone" />
                      {{ post.esmr ? post.esmr : 0 | kmbFormatter }}
                    </span>

                    <span
                      v-if="post.source != 'review'"
                      class="m-r-10 m-l-5 post-number"
                      title="Engagement"
                    >
                      <i class="bi bi-share-fill" />
                      {{
                        post.engagement_count
                          ? post.engagement_count
                          : 0 | kmbFormatter
                      }}
                    </span>
                  </div>
                  <span
                    v-if="
                      !sosmed_list.includes(post.source) &&
                        post.source != 'media_tv' &&
                        post.source != 'media_cetak'
                    "
                    class="m-r-10 m-l-5 post-number hoverable"
                    @click="viewAccountDetail(post)"
                    title="Sumber"
                  >
                    <i class="bi bi-globe-americas" />
                    {{ post.account ? post.account : "Tidak Tercantum" }}
                  </span>
                  <span
                    v-if="post.source == 'media_cetak'"
                    class="m-r-10 m-l-5 post-number hoverable"
                    title="Sumber Media Cetak"
                    @click="viewAccountDetail(post)"
                  >
                    <i class="bi bi-newspaper" />
                    {{ post.account ? post.account : "Tidak Tercantum" }}
                  </span>
                  <span
                    v-if="post.source == 'media_tv'"
                    class="m-r-10 m-l-5 post-number hoverable"
                    title="Channel TV - Nama Program"
                    @click="viewAccountDetail(post)"
                  >
                    <i class="bi bi-tv" />
                    {{ post.account ? post.account : "Tidak Tercantum" }} -
                    {{ post.program ? post.program : "Tidak Tercantum" }}
                  </span>
                  <span
                    v-if="
                      post.source == 'media_cetak' || post.source == 'media_tv'
                    "
                    class="m-r-10 m-l-5 post-number"
                    title="Jurnalis"
                  >
                    <i class="bi bi-person" />
                    {{ post.journalist ? post.journalist : "Tidak Tercantum" }}
                  </span>
                  <span
                    v-if="post.source == 'news' && post.author"
                    class="m-r-10 m-l-5 post-number"
                    title="Jurnalis"
                  >
                    <i class="bi bi-person" />
                    {{ post.author ? post.author : "Tidak Tercantum" }}
                  </span>
                  <!-- <span
                    v-if="
                      post.source == 'media_cetak' || post.source == 'media_tv'
                    "
                    class="m-r-10 m-l-5 post-number"
                    title="Ad Value"
                  >
                    <b>AD</b> IDR
                    {{
                      post.rate_fc > 0 && post.rate_fc > 0
                        ? post.rate_fc
                        : post.rate_fc > 0 && post.rate_bw == 0
                        ? post.rate_fc
                        : post.rate_fc == 0 && post.rate_bw > 0
                        ? post.rate_bw
                        : 0 | kmbFormatter
                    }}
                  </span> -->
                  <span
                    v-if="'ad_value' in post"
                    class="m-r-10 m-l-5 post-number"
                    title="Ad Value"
                  >
                    <b>AD</b> IDR {{ post.ad_value | kmbFormatter }}
                  </span>

                  <span
                    v-if="'pr_value' in post"
                    class="m-r-10 m-l-5 post-number"
                    title="Public Relations Value"
                  >
                    <b>PR</b> IDR {{ post.pr_value | kmbFormatter }}
                  </span>
                  <span
                    v-if="'amec' in post"
                    class="m-r-10 m-l-5 post-number"
                    title="Amec Value"
                  >
                    <b>a</b> {{ post.amec ? post.amec : 0 }}
                  </span>
                  <span
                    v-if="post.source == 'media_cetak'"
                    class="m-r-10 m-l-5 post-number"
                    title="Nomor Halaman"
                  >
                    <b>HAL</b> {{ post.page }}
                  </span>
                  <div class="m-r-10" v-if="isAdmin">
                    <select
                      name="sentiment"
                      :class="'select-sentimen sentimen' + post.sentiment"
                      @change="changeSentimen(index)"
                    >
                      <option value="1" :selected="post.sentiment == 1">
                        Positif
                      </option>
                      <option value="0" :selected="post.sentiment == 0">
                        Netral
                      </option>
                      <option value="-1" :selected="post.sentiment == -1">
                        Negatif
                      </option>
                    </select>
                  </div>
                  <div class="m-r-5" v-else>
                    <span
                      class="label"
                      :class="
                        post.sentiment == 1
                          ? 'label-success'
                          : post.sentiment == 0
                          ? 'label-info'
                          : 'label-danger'
                      "
                      >{{
                        post.sentiment == 1
                          ? "Positif"
                          : post.sentiment == 0
                          ? "Netral"
                          : "Negatif"
                      }}</span
                    >
                  </div>
                  <span
                    v-if="post.highlight"
                    class="post-number m-r-5"
                    title="Serupa dengan posting di highlight"
                  >
                    <i class="bi bi-star-fill" style="color: #ffc107" />
                  </span>
                  <div
                    v-if="
                      'emotion' in post &&
                        isAdmin &&
                        post.source != 'news' &&
                        post.source != 'media_cetak' &&
                        post.source != 'media_tv'
                    "
                    :id="'emotion-' + index"
                    class="tooltip-content"
                    style="width: 100%"
                  >
                    <div style="width: 100%">
                      <div
                        class="emot-wrapper"
                        align="center"
                        @click.prevent="changeEmotion(index, 0)"
                      >
                        <a
                          href="#"
                          class="m-r-5 text-black emotion-icon"
                          title="Netral"
                        >
                          <i class="bi bi-emoji-neutral" />
                        </a>
                        <p class="text-secondary">Netral</p>
                      </div>
                      <div
                        class="emot-wrapper"
                        align="center"
                        @click.prevent="changeEmotion(index, 1)"
                      >
                        <a
                          href="#"
                          class="m-r-5 text-success emotion-icon"
                          title="Senang"
                        >
                          <i class="bi bi-emoji-smile" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Senang</p>
                      </div>
                      <div
                        class="emot-wrapper"
                        align="center"
                        @click.prevent="changeEmotion(index, 2)"
                      >
                        <a
                          href="#"
                          class="m-r-5 text-warning emotion-icon"
                          title="Takut"
                        >
                          <i class="bi bi-emoji-dizzy" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Takut</p>
                      </div>
                      <div
                        class="emot-wrapper"
                        align="center"
                        @click.prevent="changeEmotion(index, 3)"
                      >
                        <a
                          href="#"
                          class="m-r-5 text-blue emotion-icon"
                          title="Sedih"
                        >
                          <i class="bi bi-emoji-frown" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Sedih</p>
                      </div>
                      <div
                        class="emot-wrapper"
                        align="center"
                        @click.prevent="changeEmotion(index, 4)"
                      >
                        <a
                          href="#"
                          class="m-r-5 text-danger emotion-icon"
                          title="Marah"
                        >
                          <i class="bi bi-emoji-angry" />
                        </a>
                        <p class="m-0 p-0 text-secondary">Marah</p>
                      </div>
                    </div>
                  </div>

                  <span
                    v-if="
                      'emotion' in post &&
                        isAdmin &&
                        post.source != 'news' &&
                        post.source != 'media_cetak' &&
                        post.source != 'media_tv'
                    "
                    :id="'actual-emotion-' + index"
                    class="post-number"
                    v-tooltip.top.click="{
                      html: 'emotion-' + index,
                      class: 'tooltip-custom',
                    }"
                  >
                    <i
                      v-if="post.emotion == 0"
                      class="bi bi-emoji-neutral"
                      style="font-size: 16px"
                      title="Netral"
                    />
                    <i
                      v-if="post.emotion == 1"
                      class="bi bi-emoji-smile text-success"
                      style="font-size: 16px"
                      title="Senang"
                    />
                    <i
                      v-if="post.emotion == 2"
                      class="bi bi-emoji-dizzy text-warning"
                      style="font-size: 16px"
                      title="Takut"
                    />
                    <i
                      v-if="post.emotion == 3"
                      class="bi bi-emoji-frown text-blue"
                      style="font-size: 16px"
                      title="Sedih"
                    />
                    <i
                      v-if="post.emotion == 4"
                      class="bi bi-emoji-angry text-danger"
                      style="font-size: 16px"
                      title="Marah"
                    />
                  </span>
                  <span v-else>
                    <span
                      v-if="
                        post.source != 'news' &&
                          post.source != 'media_cetak' &&
                          post.source != 'media_tv'
                      "
                      :id="'actual-emotion-' + index"
                      class="post-number"
                    >
                      <i
                        v-if="post.emotion == 0"
                        class="bi bi-emoji-neutral"
                        style="font-size: 16px"
                        title="Netral"
                      />
                      <i
                        v-if="post.emotion == 1"
                        class="bi bi-emoji-smile text-success"
                        style="font-size: 16px"
                        title="Senang"
                      />
                      <i
                        v-if="post.emotion == 2"
                        class="bi bi-emoji-dizzy text-warning"
                        style="font-size: 16px"
                        title="Takut"
                      />
                      <i
                        v-if="post.emotion == 3"
                        class="bi bi-emoji-frown text-blue"
                        style="font-size: 16px"
                        title="Sedih"
                      />
                      <i
                        v-if="post.emotion == 4"
                        class="bi bi-emoji-angry text-danger"
                        style="font-size: 16px"
                        title="Marah"
                      />
                    </span>
                  </span>
                </div>
                <div class="post-text-content">
                  <div
                    class="text-content"
                    :id="'text-content-' + index"
                    v-html="writeContent(post.content)"
                  />
                  <div
                    v-if="
                      post.in_medias &&
                        post.in_medias != null &&
                        post.in_medias != undefined
                    "
                    class="in-medias m-t-10 hide"
                    id="media"
                  >
                    <div
                      v-for="(in_media, in_media_index) in post.in_medias"
                      :key="in_media_index"
                      class="post-img-wrapper"
                      align="center"
                    >
                      <img
                        v-if="in_media.type == 'photo'"
                        :height="heightwidthphotos(in_media, 'height')"
                        :width="heightwidthphotos(in_media, 'width')"
                        :src="in_media.media_url_https"
                        alt="Image Post"
                        style="width: auto"
                      />
                    </div>
                  </div>
                  <div
                    v-if="post.photo"
                    class="in-medias m-t-10 hide"
                    id="media"
                  >
                    <img :src="post.photo" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row post-action m-t-10">
              <div class="col-md-12 col-sm-12 col-lg-12">
                <div class="row">
                  <div class="col-md-1 col-1">
                    <div v-if="isAdmin" class="form-check success m-b-0">
                      <input
                        type="checkbox"
                        :id="'check' + index"
                        v-model="item_checked[index]"
                      />
                      <label :for="'check' + index" />
                    </div>
                  </div>
                  <div v-if="post.source == 'twitter'" class="col-md-3 col-11">
                    <div v-if="post.topics">
                      Topik:
                      <div
                        v-for="(t, tIndex) in post.topics"
                        :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                      >
                        <span
                          v-if="!isViewer"
                          class="bi bi-x text-danger fa-lg"
                          @click="deleteTopik(t.$oid, index)"
                        >
                          &nbsp;</span
                        >
                        <span v-if="!isViewer" class="mr-1">|</span>
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      post.source == 'facebook' ||
                        post.source == 'instagram' ||
                        post.source == 'youtube' ||
                        post.source == 'linkedin' ||
                        post.source == 'tiktok' ||
                        post.source == 'forum' ||
                        post.source == 'blog'
                    "
                    class="col-md-5 col-11"
                  >
                    <div v-if="post.topics">
                      Topik:
                      <div
                        v-for="(t, tIndex) in post.topics"
                        :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                      >
                        <span
                          v-if="!isViewer"
                          class="bi bi-x text-danger fa-lg"
                          @click="deleteTopik(t.$oid, index)"
                        >
                          &nbsp;</span
                        >
                        <span v-if="!isViewer" class="mr-1">|</span>
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-md-5 col-11">
                    <div v-if="post.topics">
                      Topik:
                      <div
                        v-for="(t, tIndex) in post.topics"
                        :key="tIndex"
                        class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                      >
                        <span
                          v-if="!isViewer"
                          class="bi bi-x text-danger fa-lg"
                          @click="deleteTopik(t.$oid, index)"
                        >
                          &nbsp;</span
                        >
                        <span v-if="!isViewer" class="mr-1">|</span>
                        <span>{{ showTopicName(t.$oid) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-12" v-if="post.source == 'twitter'">
                    <div class="in-reply" v-if="post.in_reply_to">
                      <div
                        class="in-reply-to"
                        v-if="post.in_reply_to.name && post.in_reply_to.id"
                      >
                        in reply to:
                        <a
                          :href="
                            'https://twitter.com/' +
                              post.in_reply_to.name +
                              '/status/' +
                              post.in_reply_to.id
                          "
                          style="color: blue; opacity: 0.8 !important"
                          target="__blank"
                          >@{{ post.in_reply_to.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-12 post-action-button-wrap"
                    align="right"
                  >
                    <span
                      class="m-r-10 text-success font-weight-bolder hoverable clickable"
                      @click.prevent="showDetailModal(index, post)"
                    >
                      <i class="bi bi-eye"></i>
                      Lihat Detail
                    </span>
                    <span
                      v-if="post.is_validated != true"
                      class="m-r-10 text-warning font-weight-bold clickable hoverable"
                      @click.prevent="validatePost(post._id)"
                      style="font-weight: 10px"
                    >
                      <i class="i bi-patch-check"></i>
                      Validasi
                    </span>
                    <a
                      v-if="
                        post.source != 'media_cetak' &&
                          post.source != 'media_tv'
                      "
                      class="m-r-10 text-decoration-none font-weight-bolder hoverable"
                      :href="post.url"
                      style="color: #17a2b8 !important; opacity: 1"
                      target="_blank"
                      ><i class="bi bi-box-arrow-up-right" /> Kunjungi</a
                    >

                    <span
                      class="m-r-10 font-weight-bolder text-danger hoverable clickable"
                      v-if="isAdmin"
                      @click="deletePost(index)"
                      ><i class="bi bi-trash" /> Hapus</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
    <div
      class="row"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-left: 0px !important;
        margin-right: 0px !important;
      "
    >
      <div class="col-md-4">
        {{ paginationInfo() }}
      </div>
      <div class="col-md-8 p-l-1 p-r-0">
        <pagination-component
          v-if="page_info"
          :data="page_info"
          :goto="true"
          class="pull-right"
        />
      </div>
    </div>
    <modal-detail-post-component
      v-if="isShowModalDetail"
      :id_stream="modal_post._id.$oid"
      :index="index"
      :key="modal_post_key"
      @close="closeModalDetail"
    />
    <modal-advance-search
      v-if="show_modal_advance"
      :key="modal_advance_key"
      @close="closeModalAdvance"
    />
    <modal-dynamic-component
      v-if="show_modal_dynamic"
      :key="modal_dynamic_key"
      modal_id="modal-edit-stream"
      :modal="modal_dynamic"
      :data="modal_dynamic_data"
      modal_size="modal-lg"
    />
    <floating-loader-component
      :key="float_loading_key"
      v-if="is_float_loading"
      :text="float_loading_text"
    />
  </div>
</template>

<script>
import $ from "jquery";
import modal_detail_post from "@/views/components/mention/modal_detail_post.vue";
import pagination from "@/views/components/pagination.vue";
import Multiselect from "vue-multiselect";
import gp from "@/plugins/generalPlugins.js";
import swal from "sweetalert";
import axios from "axios";
import notif from "@/assets/js/notif.js";
import { isMobile } from "mobile-device-detect";
import floating_loader from "@/views/components/floating_loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_news_trend from "@/views/components/mention/modal_add_to_news_trend.vue";
import modal_advance_search from "@/views/components/mention/modal_advance_search.vue";
import post_share from "@/views/components/mention/modal_share_post.vue";
import * as linkify from "linkifyjs";
import linkifyHtml from "linkifyjs/html";
import hashtag from "linkifyjs/plugins/hashtag";
hashtag(linkify);
import Mark from "mark.js";
$.pgNotification = notif;

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["review"] = "bi bi-phone";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["view"] = "bi bi-eye";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";
post_meta["play"] = "bi bi-play";

var youtube_meta = [];
youtube_meta["comment"] = "bi bi-chat-fill";
youtube_meta["view"] = "bi bi-eye";
youtube_meta["like"] = "bi bi-hand-thumbs-up";
youtube_meta["dislike"] = "bi bi-hand-thumbs-down";
youtube_meta["favorite"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Like";
post_attribute["like"] = "Like";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Share";
post_attribute["comment"] = "Comment";
post_attribute["view"] = "View";
post_attribute["play"] = "Play";

var youtube_attribute = [];
youtube_attribute["favorite"] = "Favorite";
youtube_attribute["like"] = "Like";
youtube_attribute["dislike"] = "Dislike";
youtube_attribute["comment"] = "Comment";
youtube_attribute["view"] = "View";

export default {
  name: "post_list",
  props: {
    posts: Object,
    string_limit: {
      type: String,
      default: "200",
    },
    pers: Array,
    topics: Object,
    highlights: {
      type: Array,
      default: function() {
        return [];
      },
    },
    keyword: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    Multiselect,
    "pagination-component": pagination,
    "floating-loader-component": floating_loader,
    "modal-advance-search": modal_advance_search,
    "modal-detail-post-component": modal_detail_post,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      multiple_tier:
        "tier" in this.$route.query
          ? this.setInitialTier(this.$route.query.tier)
          : [],
      tier_options: [
        { name: "Tier 1", value: "1" },
        { name: "Tier 2", value: "2" },
        { name: "Tier 3", value: "3" },
        { name: "Tier 4", value: "4" },
      ],
      kliping: {
        ad_value: true,
        pr_value: true,
        tipe_media: true,
      },
      options: [
        { value: "Media Sosial", text: "Media Sosial" },
        { value: "Media Konvensional", text: "Media Konvensional" },
      ],
      index: null,
      data: this.posts.posts,
      page_info: this.posts.page_info,
      isShowModalDetail: false,
      modal_post: null,
      modal_post_key: 0,
      show_modal_advance: false,
      modal_advance_key: 100,
      sosmed_icon: sosmed_icon,
      check_all: false,
      stringLimit: this.string_limit,
      itemChecked: [],
      post_meta: post_meta,
      per_page: this.posts.page_info ? this.posts.page_info.limit : 10,
      sort: "sort" in this.$route.query ? this.$route.query.sort : "date",
      search: this.$route.query.q ? this.$route.query.q : null,
      isPers: "pers" in this.$route.query ? this.$route.query.pers : 2,
      tier: "tier" in this.$route.query ? this.$route.query.tier : 0,
      sosmed_list: [
        "facebook",
        "instagram",
        "twitter",
        "tiktok",
        "youtube",
        "linkedin",
        "forum",
        "blog",
        "review",
      ],
      post_attribute: post_attribute,
      youtube_meta: youtube_meta,
      youtube_attribute: youtube_attribute,
      sentiment_checked: "",
      emotion_checked: "",
      validate_checked: "",
      total_page: null,
      is_mobile: isMobile,
      show_modal_dynamic: false,
      item_checked: [],
      id_project: this.$store.getters.user.id_project,
      is_float_loading: false,
      highlight_list: [],
      is_highlight:
        "highlight" in this.$route.query
          ? this.$route.query.highlight == 1
            ? 1
            : 0
          : 0,
      tipe_project: this.$store.getters.user.project.project_detail.tipe,
      emotion_loading: false,
      modal_dynamic: null,
      modal_dynamic_key: 30,
      modal_dynamic_data: [],
      isFilter:
        "q" in this.$route.query ||
        "account" in this.$route.query ||
        "excludes" in this.$route.query ||
        "cakupan" in this.$route.query ||
        "pers" in this.$route.query ||
        "tier" in this.$route.query ||
        "sort" in this.$route.query ||
        "page" in this.$route.query ||
        "items" in this.$route.query
          ? true
          : false,
      news_trend: this.$store.getters.user.project.project_detail.news_trend,
      hoax_detection:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
              .hoax_detection
          : 0,
      is_newstrend:
        this.$store.getters.user.capabilities != null
          ? this.$store.getters.user.capabilities.newstrend
          : "",
    };
  },
  methods: {
    setInitialTier(tier) {
      const result = tier.split(",").map((value) => ({
        name: `Tier ${value}`,
        value: value,
      }));
      return result;
    },
    tierChanged() {
      const result = this.multiple_tier.map((item) => item.value).join(",");
      if (result) {
        this.tier = result;
      } else {
        this.tier = "0";
      }
    },
    validatePost(id) {
      let self = this;
      let params = {
        _id: id.$oid,
        is_validated: 1,
      };
      event.preventDefault();
      swal({
        title: "Apakah anda yakin?",
        text: "Akan memvalidasi postingan ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "validated-update";
          axios
            .put(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.$parent.isLoading = true;
                self.$parent.getData();
                self.$parent.getFiltersData();
                self.$parent.getFiltersSentiment();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Postingan berhasil divalidasi.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal memvalidasi data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function() {
              swal(
                "Error!",
                "Terjadi kesalahan saat memvalidasi data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    validatePostAll() {
      let self = this;
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          is_validated: 1,
        };

        swal({
          title: "Apakah anda yakin?",
          text: "Akan memvalidasi postingan yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "validated-update-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  self.$parent.isLoading = true;
                  self.$parent.getData();
                  self.$parent.getFiltersData();
                  self.$parent.getFiltersSentiment();
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Postingan berhasil divalidasi.',
                      position: "top",
                      timeout: 4000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal memvalidasi data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat memvalidasi data. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        });
      }
    },
    showAdvanceSearch: function() {
      this.show_modal_advance = true;
    },
    closeModalAdvance: function() {
      this.show_modal_advance = false;
    },
    deleteTopik: function(id, index) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus topik tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let topics = [id];
          let api = process.env.VUE_APP_API_URL + "delete-stream-topic";
          let params = {
            _id: this.data[index]._id.$oid,
            topics: topics,
          };

          axios
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.$parent.getData();
              }
            })
            .catch(function() {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    viewAccountDetail: function(post) {
      let account = post;
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account.id_account) },
      });
    },
    showDetailModal: function(index, post) {
      this.index = index;
      this.modal_post = post;
      this.modal_post_key++;
      this.isShowModalDetail = true;
    },
    closeModalDetail: function() {
      this.isShowModalDetail = false;
    },
    dateindo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
    newDateIndo: function(tanggal) {
      return gp.dateIndonesia(tanggal);
    },
    convertDate: function(tanggal) {
      return gp.convertDate(tanggal);
    },
    showAction: function() {
      $("#action-tersembunyi").slideDown();
    },
    hideAction: function() {
      this.check_all = false;
      for (let i = 0; i < this.data.length; i++) {
        $("#check" + i).prop("checked", false);
        this.item_checked[i] = false;
      }
      $("#action-tersembunyi").slideUp();
    },
    writeContent: function(text) {
      var batasKata = this.stringLimit;
      var newText = text.substring(0, batasKata);
      var last_index = newText.lastIndexOf(" ");
      var cekMark = text.substring(last_index);
      if (newText.length == batasKata) {
        if (cekMark.includes("mark")) {
          newText = newText.substring(0, last_index);
        }
        newText += "...";
      }

      if ("q" in this.$route.query) {
        newText = this.markString(newText);
      }
      // newText = this.createAutoLink(newText);
      newText = newText.replace(/\n/g, "<br />");

      return newText;
    },
    createAutoLink: function(text) {
      return linkifyHtml(text, {
        defaultProtocol: "https",
        ignoreTags: ["mark"],
        validate: {
          url: function(value) {
            return /^(http|ftp)s?:\/\//.test(value);
          },
        },
      });
    },
    changeSentimen: function(index) {
      event.preventDefault();
      var tgt = event.target;
      var val_before = this.data[index].sentiment;
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan mengubah sentimen posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          var newValue = $(tgt)[0].value;
          let params = {
            _id: this.data[index]._id.$oid,
            sentiment: parseInt(newValue),
          };
          this.$parent.isLoading = true;
          let api = process.env.VUE_APP_API_URL + "post-sentiment";
          axios
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.data[index].updated_sentiment = 1;
                self.data[index].sentiment = parseInt(newValue);
                if ("updated_value" in response.data) {
                  self.data[index].pr_value =
                    response.data.updated_value.pr_value;
                }
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sentimen berhasil diubah.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function() {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah sentimen.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.$parent.isLoading = false;
            });
        } else {
          $(tgt).val(val_before);
          this.data[index].sentiment = val_before;
        }
      });
    },
    deletePost: function(index) {
      let self = this;
      let params = {
        _id: this.data[index]._id.$oid,
      };
      event.preventDefault();
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-delete";
          axios
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.$parent.isLoading = true;
                self.$parent.getData();
                self.$parent.getFiltersData();
                self.$parent.getFiltersSentiment();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function() {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    thousandSeparator: function(str) {
      return gp.thousandSeparator(str);
    },
    imageUrlAlt: function() {
      event.target.src = "/assets/img/profiles/default.png";
    },
    paginationInfo: function() {
      let text = "";
      if (this.page_info != null) {
        let data_start =
          this.page_info.limit * this.page_info.page -
          (this.page_info.limit - 1);
        let data_end = this.page_info.limit * this.page_info.page;
        if (data_end > this.page_info.total) {
          data_end = this.page_info.total;
        }
        text =
          "Menampilkan " +
          data_start +
          " - " +
          data_end +
          " dari " +
          this.thousandSeparator(this.page_info.total);
      }

      return text;
    },
    cekPers: function(_id) {
      if (this.pers != null) {
        return this.pers.includes(_id);
      } else {
        return false;
      }
    },
    searchPost() {
      let text = this.search;
      if ("q" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.q = text;
        if (text == "") {
          this.deleteParam("q");
        } else {
          queries.page = 1;
          this.$router.replace({ query: queries });
          this.isFilter = true;
        }
      } else {
        if (text) {
          this.isFilter = true;
          this.$router.replace({
            query: Object.assign({}, this.$route.query, { q: text }),
          });
        }
      }
    },
    resetFilter() {
      this.isFilter = false;
      this.search = "";
      if ("account" in this.$route.query) {
        this.deleteParam("account");
      }
      if ("excludes" in this.$route.query) {
        this.deleteParam("excludes");
      }
      if ("cakupan" in this.$route.query) {
        this.deleteParam("cakupan");
      }
      if ("tier" in this.$route.query) {
        this.deleteParam("tier");
      }
      if ("sort" in this.$route.query) {
        this.deleteParam("sort");
      }
      if ("pers" in this.$route.query) {
        this.deleteParam("pers");
      }
      if ("page" in this.$route.query) {
        this.deleteParam("page");
      }
      if ("items" in this.$route.query) {
        this.deleteParam("items");
      }
      this.searchPost();
    },
    deleteParam: function(key) {
      let queries = this.$route.query;
      delete queries[key];
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
    },
    showTopicName: function(_id) {
      if (this.topics != null) {
        for (let grup in this.topics.formed) {
          for (let topic in this.topics.formed[grup].topics) {
            if (_id == topic) {
              return this.topics.formed[grup].topics[topic];
            }
          }
        }
        if (_id in this.topics.socmed) {
          return this.topics.socmed[_id];
        } else {
          return "Topik Dihapus";
        }
      } else {
        return "Topik Dihapus";
      }
    },
    deleteChecked: function() {
      if (this.item_checked.includes(true)) {
        let self = this;
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
        };

        event.preventDefault();

        swal({
          title: "Apakah anda yakin?",
          text: "Akan menghapus posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-delete-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  self.$parent.isLoading = true;
                  if (
                    this.page_info.page == this.total_page &&
                    this.page_info.page > 1 &&
                    this.data.length == post_checked_id.length
                  ) {
                    let current_page = this.page_info.page - 1;
                    let queries = JSON.parse(JSON.stringify(this.$route.query));
                    queries.page = current_page;
                    this.$router.replace({ query: queries });
                  } else {
                    self.$parent.getData();
                    self.$parent.getFiltersData();
                    self.$parent.getFiltersSentiment();
                  }

                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        });
      }
    },
    changeSentimentChecked: function(sentiment_id) {
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          sentiment: parseInt(sentiment_id),
        };
        swal({
          title: "Apakah anda yakin?",
          text: "Akan mengubah sentimen posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-sentiment-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  for (let key in this.item_checked) {
                    if (this.item_checked[key] === true) {
                      this.data[key].sentiment = sentiment_id;
                      this.data[key].updated_sentiment = 1;
                    }
                  }
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sentimen posting berhasil diubah.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              })
              .finally(() => {
                this.hideAction();
                this.sentiment_checked = "";
              });
          } else {
            this.sentiment_checked = "";
          }
        });
      }
    },
    changeEmotionChecked: function(emotion_id) {
      if (this.item_checked.includes(true)) {
        let post_checked_id = [];
        for (let key in this.item_checked) {
          if (this.item_checked[key] === true) {
            post_checked_id.push(this.data[key]._id.$oid);
          }
        }
        let params = {
          _id: post_checked_id,
          emotion: parseInt(emotion_id),
        };
        swal({
          title: "Apakah anda yakin?",
          text: "Akan mengubah emotion posting yang ditandai.",
          icon: "warning",
          buttons: ["Tidak", "Ya"],
          dangerMode: true,
          className: "swal-custom",
        }).then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "post-emotion-many";
            axios
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  for (let key in this.item_checked) {
                    if (this.item_checked[key] === true) {
                      this.data[key].emotion = emotion_id;
                      this.data[key].updated_emotion = 1;
                    }
                  }
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Emotion posting berhasil diubah.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal mengupdate data. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(() => {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat mengupdate data. Silahkan coba lagi.",
                  "warning"
                );
              })
              .finally(() => {
                this.hideAction();
                this.emotion_checked = "";
              });
          } else {
            this.emotion_checked = "";
          }
        });
      }
    },
    markString: function(content, marked_word = []) {
      let kata = [];
      if ("q" in this.$route.query) {
        kata = this.$route.query.q;
        kata = gp.extractPhrase(kata);
      }

      if (marked_word.length > 0) {
        marked_word.forEach((word) => {
          word = gp.extractPhrase(word);
          if (
            word.every((w) => content.toLowerCase().includes(w.toLowerCase()))
          ) {
            word.forEach((w) => {
              w = w.trim();
              kata.push(w);
            });
          }
        });
      }
      kata = [...new Set(kata)];
      kata.forEach(function(word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
    unmark: function() {
      var context = document.querySelector(".post-items");
      var instance = new Mark(context);
      instance.unmark();
    },
    eksporSelectedKliping: function(type) {
      let filterTrue = this.item_checked.filter((el) => el == true);
      if (filterTrue.length > 40) {
        $("body")
          .pgNotification({
            style: "bar",
            message:
              '<i class="bi bi-exclamation-circle"></i> <b>Perhatian !</b> Maks. Berita yang dapat dikliping dalam 1 file hanya 40 berita',
            position: "top",
            timeout: 5000,
            type: "danger",
          })
          .show();
      } else {
        if (this.item_checked.includes(true)) {
          let post_checked_id = [];
          for (let key in this.item_checked) {
            if (this.item_checked[key] === true) {
              post_checked_id.push(this.data[key]._id.$oid);
            }
          }

          if (post_checked_id.length > 0) {
            let api;
            let nama_file;

            if (type == "docx") {
              api =
                process.env.VUE_APP_API_URL +
                "docxSelectedClips/" +
                this.id_project;
              nama_file =
                "Online Media Clipping Reports - " +
                gp.date(Date.now()).format("YYYYMMDDHHmmss") +
                ".docx";
            } else {
              api =
                process.env.VUE_APP_API_URL +
                "printSelectedClips/" +
                this.id_project;
              nama_file =
                "Online Media Clipping Reports - " +
                gp.date(Date.now()).format("YYYYMMDDHHmmss") +
                ".pdf";
            }

            let param = {
              clipping_ids: btoa(post_checked_id.join(",")),
              time: gp.date(Date.now()).format("YYYYMMDDHHmmss"),
              ad_value: this.kliping.ad_value == true ? 1 : 0,
              pr_value: this.kliping.pr_value == true ? 1 : 0,
              tipe_media_source: this.kliping.tipe_media == true ? 1 : 0,
            };
            // open new tab
            const fileURL =
              api +
              "?clipping_ids=" +
              param.clipping_ids +
              "&time=" +
              param.time +
              "&ad_value=" +
              param.ad_value +
              "&pr_value=" +
              param.pr_value +
              "&tipe_media_source=" +
              param.tipe_media_source;

            const link = document.createElement("a");
            link.href = fileURL;
            link.target = "_blank";
            link.setAttribute("download", nama_file);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }
    },
    highlightPost: function(index) {
      let params = {
        _id: this.data[index]._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghiglight posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      })
        .then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "highlight-add";
            this.$http
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  this.highlight_list.push({ $oid: params._id });
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil ditambahkan kedalam daftar highlight.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus menghiglight posting. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(function() {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghiglight posting. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        })
        .catch(() => {
          swal(
            "Error!",
            "Terjadi kesalahan saat menghiglight posting. Silahkan coba lagi.",
            "warning"
          );
        });
    },
    unhighlightPost: function(index) {
      let params = {
        _id: this.data[index]._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus highlight posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      })
        .then((yess) => {
          if (yess) {
            let api = process.env.VUE_APP_API_URL + "highlight-remove";
            this.$http
              .post(api, params)
              .then((response) => {
                if (response.status == 200) {
                  this.getHighlight();
                  $("body")
                    .pgNotification({
                      style: "bar",
                      message:
                        '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Highlight berhasil dihilangkan.',
                      position: "top",
                      timeout: 5000,
                      type: "success",
                    })
                    .show();
                } else {
                  swal(
                    "Error!",
                    "Gagal menghapus menghiglight posting. Silahkan coba lagi.",
                    "warning"
                  );
                }
              })
              .catch(function() {
                swal(
                  "Error!",
                  "Terjadi kesalahan saat menghapus higlight posting. Silahkan coba lagi.",
                  "warning"
                );
              });
          }
        })
        .catch(() => {
          swal(
            "Error!",
            "Terjadi kesalahan saat menghapus higlight posting. Silahkan coba lagi.",
            "warning"
          );
        });
    },
    getHighlight: function() {
      let api =
        process.env.VUE_APP_API_URL + "highlight-ids/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.highlight_list = response.data;
        })
        .catch(() => {
          this.highlight_list = [];
        });
    },
    cekHiglight: function(id) {
      if (this.tipe_project == 1) {
        let is_higlight = false;
        if (this.highlight_list.length > 0) {
          is_higlight = this.highlight_list.find((obj) => obj.$oid == id);
        }
        if (is_higlight) {
          return true;
        }
      }
      return false;
    },
    changeEmotion: function(index, val) {
      if (!this.emotion_loading) {
        this.emotion_loading = true;
        let param = {
          _id: this.posts.posts[index]._id.$oid,
          emotion: parseInt(val),
        };
        let api = process.env.VUE_APP_API_URL + "post-emotion";
        this.$parent.isLoading = true;
        this.$http
          .post(api, param)
          .then((response) => {
            if (response.status == 200) {
              this.posts.posts[index].emotion = val;
              this.posts.posts[index].updated_emotion = 1;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$("#actual-emotion-" + index).trigger("click");
            this.emotion_loading = false;
            this.$parent.isLoading = false;
          });
      } else {
        alert("too fast dude!");
      }
    },
    sharePost: function() {
      let content =
        "Lihat apa yang Saya temukan di " + window.location.origin + " \n\n";
      for (let index in this.item_checked) {
        if (this.item_checked[index]) {
          let akun = this.sosmed_list.includes(this.data[index].source)
            ? this.data[index].account
            : this.data[index].title;
          let title = this.data[index].source == "twitter" ? "@" + akun : akun;
          content += title + "\n";

          if (this.sosmed_list.includes(this.data[index].source)) {
            content +=
              this.data[index].content
                .replace(/<[^>]*>/g, "")
                .substring(0, 140) + "...\n";
          }

          if (this.data[index].source == "media_cetak") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else if (this.data[index].source == "media_tv") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else if (this.data[index].source == "news") {
            content +=
              window.location.origin +
              "/view?id=" +
              this.data[index]._id.$oid +
              "\n";
          } else {
            content += this.data[index].url;
          }
          content += "\n\n";
        }
      }
      this.modal_dynamic = {
        title: "Share Post",
        subtitle: "",
        component: post_share,
      };
      let data = [];
      data["content"] = content;
      this.modal_dynamic_data = data;
      this.modal_dynamic_key++;
      this.show_modal_dynamic = true;
    },
    addNewsTrendModal: function() {
      let post_checked = [];
      for (let key in this.item_checked) {
        if (this.item_checked[key] === true) {
          if (post_checked.length > 0) {
            let tanggal = gp.timestampTodate(this.data[key].date.$date);
            let index = post_checked.findIndex(
              (obj) => obj.tanggal === tanggal
            );
            if (index != -1) {
              post_checked[index].streams.push(this.data[key]._id.$oid);
            } else {
              post_checked.push({
                tanggal: gp.timestampTodate(this.data[key].date.$date),
                streams: [this.data[key]._id.$oid],
              });
            }
          } else {
            post_checked.push({
              tanggal: gp.timestampTodate(this.data[key].date.$date),
              streams: [this.data[key]._id.$oid],
            });
          }
        }
      }
      this.modal_dynamic_data = post_checked;
      this.modal_dynamic = {
        title: "News Trend",
        subtitle: "",
        component: modal_news_trend,
      };
      if (!this.show_modal_dynamic) {
        this.show_modal_dynamic = true;
      } else {
        this.modal_dynamic_key++;
      }
    },
    autoHighlight() {
      for (let i in this.data) {
        let text = this.data[i].content;
        let keywords = [];
        if (this.data[i].topics) {
          for (let j in this.data[i].topics) {
            const topic_id = this.data[i].topics[j].$oid;
            if (
              this.keyword &&
              this.keyword[topic_id] &&
              this.keyword[topic_id]["keywords"]
            ) {
              keywords = [...keywords, ...this.keyword[topic_id]["keywords"]];
            }
          }
          this.data[i].content = this.markString(text, keywords);
        }
      }
    },
  },
  filters: {
    decimalFormater: function(value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
    showPicture: function(post) {
      let pro_pic;
      switch (post.source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "instagram":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        case "youtube":
          pro_pic = post.thumbnails;
          break;
        case "linkedin":
          pro_pic = post.profile_picture;
          break;
        case "tiktok":
          pro_pic = post.profile_picture;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function(number) {
      return gp.kmbFormatter(number);
    },
  },
  watch: {
    sentiment_checked: function() {
      if (this.sentiment_checked) {
        this.changeSentimentChecked(this.sentiment_checked);
      }
    },
    emotion_checked: function() {
      if (this.emotion_checked) {
        this.changeEmotionChecked(this.emotion_checked);
      }
    },
    per_page(item) {
      if ("items" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.items = item;
        this.$router.replace({ query: queries });
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { items: item }),
        });
      }
    },
    sort(sort_by) {
      if ("sort" in this.$route.query) {
        if (this.$route.query.sort != sort_by) {
          let queries = JSON.parse(JSON.stringify(this.$route.query));
          queries.sort = sort_by;
          this.$router.replace({ query: queries });
        }
      } else {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, { sort: sort_by }),
        });
      }
      this.sort = sort_by;
    },
    isPers(is_pers) {
      let params = this.$route.query;
      params.page = 1;
      if (is_pers == 2) {
        this.deleteParam("pers");
        this.deleteParam("tier");
      } else if (is_pers == 0) {
        this.deleteParam("tier");
        this.$router.replace({
          query: Object.assign({}, params, { pers: is_pers }),
        });
      } else {
        this.$router.replace({
          query: Object.assign({}, params, { pers: is_pers }),
        });
      }
    },
    tier(tier) {
      let params = this.$route.query;
      params.page = 1;
      if (tier != 0) {
        this.$router.replace({
          query: Object.assign({}, params, { tier: tier }),
        });
      } else {
        this.deleteParam("tier");
      }
    },
    is_highlight() {
      if ("highlight" in this.$route.query) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.highlight = this.is_highlight ? 1 : 0;
        this.$router.replace({ query: queries });
      } else {
        let highlight = this.is_highlight ? 1 : 0;
        let params = this.$route.query;
        params.page = 1;
        this.$router.replace({
          query: Object.assign({}, params, { highlight: highlight }),
        });
      }
    },
    itemChecked() {
      if (this.itemChecked.length == 0) {
        this.check_all = false;
      }
      if (this.itemChecked.length == this.data.length) {
        this.check_all = true;
      }
    },
    check_all() {
      if (this.check_all == true) {
        for (let i = 0; i < this.data.length; i++) {
          this.item_checked[i] = true;
        }
        this.showAction();
      } else {
        this.hideAction();
      }
    },
    item_checked() {
      if (this.item_checked.includes(true)) {
        this.showAction();
      } else {
        $("#action-tersembunyi").slideUp();
      }
    },
  },
  computed: {
    isAdmin: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }
      return false;
    },
    isViewer: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 4) {
        return true;
      }
      return false;
    },
    heightwidthphotos: function() {
      return (data, type) => {
        if (type === "height") {
          return data.sizes?.small?.h || 200;
        } else if (type === "width") {
          return data.sizes?.small?.w || 200;
        }
        return 200;
      };
    },
  },
  created() {
    if ("q" in this.$route.query) {
      this.isFilter = true;
    }
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.isShowModalDetail = false;
      }
    });
  },
  mounted: function() {
    this.autoHighlight();
    let self = this;
    $(".post-wrapper").on("#modal_sumber hidden.bs.modal", function() {
      self.isShowModalDetail = false;
    });
  },
};
</script>

<style>
.tooltip-custom {
  background-color: rgb(255, 255, 255) !important;
}
.emotion-icon:hover {
  color: none;
}
.emotion-icon {
  font-size: 22px;
}
</style>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
.perpage-el {
  padding: 0px;
}
.perpage-el i {
  font-size: 18px;
}
.text-content {
  text-align: justify;
}
.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}
.input-group-text {
  font-size: 12px;
}
.post-items {
  margin-bottom: 20px;
}
.select2-container {
  z-index: 1 !important;
}
.user-pic {
  width: 100% !important;
  height: auto !important;
  position: relative;
}
.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}
.twitter-border {
  border: 2px solid skyblue;
}
.post-action {
  display: block;
}
.select-sentimen {
  background: none;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 5px;
  font-weight: bold;
  opacity: 1 !important;
  cursor: pointer;
}
.sentimen1 {
  border-color: #28a745;
  color: #28a745;
}
.sentimen-1 {
  border-color: #dc3545;
  color: #dc3545;
}
.sentimen0 {
  border-color: #0e6d87;
  color: #0e6d87;
}
.propic-badge {
  position: absolute;
  right: 15%;
  bottom: 0px;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 1px;
  height: 25px;
  width: 25px;
  max-width: 100%;
}
.post-content:hover .post-number {
  color: black;
  cursor: pointer;
  opacity: 1 !important;
}
.active {
  background: #0f8ff9 !important;
  color: #fff !important;
}
a:hover {
  color: blue !important;
  opacity: 1 !important;
}
#action-tersembunyi {
  display: none;
}
@media (max-width: 600px) {
  .propic-badge {
    position: absolute;
    right: 40%;
    top: 40px;
    font-size: 14px;
    background: white;
    border-radius: 50%;
    border: 1px #eee solid;
    padding: 2px 1px;
    height: 25px;
    width: 25px;
  }
}
select:after {
  content: " ";
  display: inline-block;
  width: 24px;
  height: 24px;
  background: blue;
}
.emot-wrapper {
  float: left;
  margin: 0px 5px;
  cursor: pointer;
}
.emot-wrapper:hover p {
  color: #0f8ff9 !important;
}
.emot-wrapper:hover a {
  color: #0f8ff9 !important;
}
select {
  cursor: pointer;
}
.post-text-content {
  padding-left: 5px;
}
</style>
